import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { isDevelopment } from '@/utils/getEnvironment';

interface GlobalState {
  // State
  headerLoaded: boolean;
  footerLoaded: boolean;

  // Actions
  setHeaderLoaded: (headerLoaded: boolean) => void;
  setFooterLoaded: (footerLoaded: boolean) => void;
}

export const useGlobalStore = create<GlobalState>()(
  devtools(
    (set) => ({
      // Initial state
      headerLoaded: false,
      footerLoaded: false,

      // Actions
      setHeaderLoaded: (headerLoaded) => set({ headerLoaded }),
      setFooterLoaded: (footerLoaded) => set({ footerLoaded }),
    }),
    {
      name: 'GlobalStore',
      enabled: isDevelopment,
    }
  )
);

// Selectors
export const selectHeaderLoaded = (state: GlobalState) => state.headerLoaded;
